import React, { createRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchUserProfileAsync, selectUser } from "./profileSlice";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";

// Utility to fill a string with 0s to a given length
const fillWithZeros = (value, length) => {
  let str = (value ?? "").toString(); // Always a string
  str = str.replace(/null|undefined|NA/gi, "");
  str = str.padEnd(length, "0");
  return str.split("").map((v) => (v && v !== " " ? v : "0"));
};

const extractDateParts = (dateStr) => {
  const [year, month, day] = dateStr?.split("-");
  return {
    day: day,
    month: month,
    year: year.slice(-2),
  };
};

function Profile() {
  let ContactInfo = [
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b78e",
      },
      name: "आधार नंबर",
      type: "number",
      placeholder: "अपना आधार नंबर दर्ज करें",
      label: "आधार नंबर",
      id: "25d2",
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b78f",
      },
      name: "प_ह_ संख्या",
      type: "number",
      placeholder: "अपना पी.एच. नंबर दर्ज करें",
      label: "प.ह.नं.",
      id: "513d",
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b790",
      },
      name: "वार्ड क्रमांक",
      type: "number",
      placeholder: "अपना वार्ड नंबर दर्ज करें",
      label: "वार्ड नं.",
      id: "2e1f",
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b791",
      },
      name: "मतदाता परिचयपत्र",
      type: "text",
      placeholder: "अपना वोटर आईडी दर्ज करें",
      label: "मतदाता परिचयपत्र",
      id: "890a",
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b793",
      },
      name: "ड्राइविंग लाइसेंस",
      type: "text",
      placeholder: "अपना ड्राइविंग लाइसेंस दर्ज करें",
      label: "ड्राइविंग लाइसेंस",
      id: "c5c8",
    },
    // {
    //   _id: {
    //     $oid: "666718d8bdaeab4fb842b78d",
    //   },
    //   name: "मो",
    //   type: "number",
    //   placeholder: "अपना विभाग दर्ज करें",
    //   label: "मो",
    //   id: "b823",
    // },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b792",
      },
      name: "परिवार आईडी",
      type: "text",
      placeholder: "अपनी पारिवारिक आईडी दर्ज करें",
      label: "परिवार आईडी",
      id: "7dab",
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b794",
      },
      name: "जन्म दिन दिनांक",
      type: "date",
      placeholder: "अपनी जन्म तिथि दर्ज करें",
      label: "जन्म दिनांक",
      id: "f5d8",
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b794",
      },
      name: "जन्म दिन दिनांक",
      type: "date",
      placeholder: "अपनी जन्म तिथि दर्ज करें",
      label: "जन्म दिनांक",
      id: "f5d8",
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b796",
      },
      name: "नियुक्ति पटेल",
      type: "text",
      placeholder: "अपना नियुक्त पटेल दर्ज करें",
      label: "नियुक्ति पटेल",
      id: "906f",
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b797",
      },
      name: "पुत्र",
      type: "text",
      placeholder: "अपने बेटे का नाम दर्ज करें",
      label: "पुत्र",
      id: "c7a7",
      require: false,
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b798",
      },
      name: "पौत्र",
      type: "text",
      placeholder: "अपने पोते का नाम दर्ज करें",
      label: "पौत्र",
      id: "6a6e",
      require: false,
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b799",
      },
      name: "पत्नी",
      type: "text",
      placeholder: "अपनी पत्नी का नाम दर्ज करें",
      label: "पत्नी",
      id: "9e62",
      require: false,
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b79a",
      },
      name: "भाई",
      type: "text",
      placeholder: "अपने भाई का नाम दर्ज करें",
      label: "भाई",
      id: "fd79",
      require: false,
    },
    {
      _id: {
        $oid: "666718d8bdaeab4fb842b79b",
      },
      name: "पुत्री",
      type: "text",
      placeholder: "अपनी बेटी का नाम दर्ज करें",
      label: "पुत्री",
      id: "b2e2",
      require: false,
    },
  ];
  const dobField = {
    _id: { $oid: "666718d8bdaeab4fb842b794" },
    name: "जन्म दिन दिनांक",
    type: "date",
    placeholder: "अपनी जन्म तिथि दर्ज करें",
    label: "जन्म दिनांक",
    id: "f5d8",
  };
  let PersonalInfo = [
    {
      _id: {
        $oid: "666718ccbdaeab4fb842b77e",
      },
      name: "नाम",
      type: "text",
      placeholder: "अपना नाम दर्ज करें",
      label: "नाम",
      id: "a5b5",
    },

    {
      _id: {
        $oid: "666718ccbdaeab4fb842b77f",
      },
      name: "पिताश्री",
      type: "text",
      placeholder: "अपने पिता का नाम दर्ज करें",
      label: "पिताश्री",
      width: "1/5",
      id: "7be4",
    },
    {
      _id: {
        $oid: "666718ccbdaeab4fb842b780",
      },
      name: "दादाश्री",
      type: "text",
      placeholder: "अपने दादा का नाम दर्ज करें",
      label: "दादाश्री",
      width: "1/5",
      id: "32ae",
    },
    {
      _id: {
        $oid: "666718ccbdaeab4fb842b781",
      },
      name: "जाति",
      type: "text",
      placeholder: "अपनी जाति दर्ज करें",
      label: "जाति",
      width: "1/5",
      id: "69ed",
    },
    {
      _id: {
        $oid: "666718ccbdaeab4fb842b782",
      },
      name: "व्यवसाय",
      type: "text",
      placeholder: "अपना पेशा दर्ज करें",
      label: "व्यवसाय",
      width: "custom-6",
      id: "c33c",
    },
    {
      _id: {
        $oid: "666718ccbdaeab4fb842b783",
      },
      name: "ग्राम",
      type: "text",
      placeholder: "अपना गाँव दर्ज करें",
      label: "ग्राम",
      id: "2495",
    },
    {
      _id: {
        $oid: "666718ccbdaeab4fb842b784",
      },
      name: "पंचायत",
      type: "text",
      placeholder: "अपनी पंचायत दर्ज करें",
      label: "पंचायत",
      id: "2231",
    },
    {
      _id: {
        $oid: "666718ccbdaeab4fb842b785",
      },
      name: "पोस्ट",
      type: "text",
      placeholder: "अपनी पोस्ट दर्ज करें",
      label: "पोस्ट",
      id: "e77c",
    },
    {
      _id: {
        $oid: "666718ccbdaeab4fb842b786",
      },
      name: "थाना",
      type: "text",
      placeholder: "अपना पुलिस स्टेशन दर्ज करें",
      label: "थाना",
      id: "3a10",
    },
    {
      _id: {
        $oid: "666718ccbdaeab4fb842b787",
      },
      name: "तहसील",
      type: "text",
      placeholder: "अपनी तहसील दर्ज करें",
      label: "तहसील",
      id: "4377",
    },

    {
      _id: {
        $oid: "666718ccbdaeab4fb842b788",
      },
      name: "उपतहसील",
      type: "text",
      placeholder: "अपना उपतहसीलदर्ज करें",
      label: "उपतहसील",
      id: "4b16",
    },

    {
      _id: {
        $oid: "666718ccbdaeab4fb842b78a",
      },
      name: "जनपद",
      type: "text",
      placeholder: "अपना विभाग दर्ज करें",
      label: "जनपद",
      id: "6dc8",
    },
    {
      _id: {
        $oid: "666718ccbdaeab4fb842b789",
      },
      name: "जिला",
      type: "text",
      placeholder: "अपना जिला दर्ज करें",
      label: "जिला",
      id: "e1ef",
    },
    {
      _id: {
        $oid: "6680041877511524890c4b8a",
      },
      name: "पारिवारिक सदस्य पटेल के उत्तराधिकारी का नाम",
      type: "text",
      placeholder: "पारिवारिक सदस्य पटेल दर्ज करें",
      label: "पारिवारिक सदस्य पटेल के उत्तराधिकारी का नाम",
    },
    {
      _id: {
        $oid: "6680041877511524890c4b8h",
      },
      name: "पारिवारिक सदस्य पटेल के उत्तराधिकारी का नाम ( नाम )",
      type: "text",
      placeholder: "पारिवारिक सदस्य पटेल दर्ज करें ( नाम )",
      label: "पारिवारिक सदस्य पटेल के उत्तराधिकारी का नाम ( नाम )",
    },
  ];
  let { id } = useParams();
  let dispatch = useDispatch();
  let data = useSelector(selectUser);
  let ref = createRef();
  // After:
  const [icons, setIcons] = useState([0, 0, 0, 0]); // 0=blank, 1=tick, 2=cross, 3=1/2, 4=OK
  const [icon1, setIcon1] = useState(false);

  useEffect(() => {
    dispatch(fetchUserProfileAsync(id));
  }, [dispatch, id]);

  // Load checkbox states when data is fetched
  useEffect(() => {
    if (data) {
      const savedIcons = [
        data.checkbox_0 || 0,
        data.checkbox_1 || 0,
        data.checkbox_2 || 0,
        data.checkbox_3 || 0
      ];
      setIcons(savedIcons);
      setIcon1(data.appointment_checkbox || false);
    }
  }, [data]);

  // Function to save checkbox state to database
  const saveCheckboxState = async (checkboxIndex, newState) => {
    try {
      const updateData = {
        [`checkbox_${checkboxIndex}`]: newState
      };

      const response = await fetch(`/updateuser?id=${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData)
      });

      if (!response.ok) {
        console.error('Failed to save checkbox state');
      }
    } catch (error) {
      console.error('Error saving checkbox state:', error);
    }
  };

  // Function to save appointment checkbox state
  const saveAppointmentCheckbox = async (newState) => {
    try {
      const updateData = {
        appointment_checkbox: newState
      };

      const response = await fetch(`/updateuser?id=${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData)
      });

      if (!response.ok) {
        console.error('Failed to save appointment checkbox state');
      }
    } catch (error) {
      console.error('Error saving appointment checkbox state:', error);
    }
  };

  let navigate = useNavigate();
  let newData = {};

  data = data?.user;
  if (data) {
    newData["नियुक्ति तिथि"] =
      data["नियुक्ति_दिनांक"]?.split("-").reverse().join("") || "00000000";
    newData["जन्म दिन दिनांक"] =
      data["जन्म_दिनांक"]?.split("-").reverse().join("") || "00000000";
  }
  function splitTextByWords(text, maxLines = 4, maxChars = 20) {
    if (!text) return [];
    const words = text.split(/\s+/);
    const lines = [];
    let currentLine = "";

    for (let i = 0; i < words.length; i++) {
      const word = words[i];
      // If adding this word exceeds maxChars, push the current line and start a new one
      if ((currentLine + (currentLine ? " " : "") + word).length > maxChars) {
        lines.push(currentLine);
        currentLine = word;
        // If we've reached maxLines-1, break and join the rest into the last line
        if (lines.length === maxLines - 1) {
          currentLine = words.slice(i).join(" ");
          break;
        }
      } else {
        currentLine += (currentLine ? " " : "") + word;
      }
    }
    if (currentLine) lines.push(currentLine);
    // Ensure we don't exceed maxLines
    return lines.slice(0, maxLines);
  }

  if (data && ContactInfo && PersonalInfo) {
    return (
      <section className="py-1 font-semibold text-base">
        <div className="w-full sm:w-full mx-auto ">
          <div
            className="relative flex flex-col min-w-0 break-words w-full  border-0"
            ref={ref}
          >
            <div className="rounded-t bg-white mb-0 px-6">
              <div
                pri
                className="text-center flex justify-between print:hidden hide-in-screenshot"
              >
                <h6 className="text-blueGray-700 text-xl ">
                  {data.नाम} Profile
                </h6>
                <button
                  className="bg-pink-500 print:hidden hide-in-screenshot text-white active:bg-pink-600  uppercase sm:text-sm lg:text-sm text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  onClick={() => window.print()}
                >
                  Print
                </button>
                <button
                  className="bg-pink-500 print:hidden hide-in-screenshot text-white active:bg-pink-600  uppercase sm:text-sm lg:text-sm text-xs  px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  onClick={() => navigate(`/edit/${id}`)}
                >
                  Edit
                </button>

                <Link
                  to="/search"
                  className="bg-pink-500 print:hidden hide-in-screenshot text-white active:bg-pink-600  uppercase sm:text-sm lg:text-sm text-xs  px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="button"
                >
                  Back
                </Link>
              </div>
            </div>
            <div className="flex-auto px-4 sm:px-3 pt-0 border-black border-2 m-4 rounded-xl">
              <form noValidate className="m-1">
                <div className="flex flex-wrap">

                  <div className="p-4 w-full">
                    <div className="flex w-full">
                      {/* Left section - क्र and icon */}
                      <div className="flex flex-col justify-start w-2/5">
                        {/* क्रमांक row */}
                        <div className="flex items-center mb-2">
                          <label
                            className="uppercase mt-1 mb-2 flex justify-center"
                            htmlFor="grid-password"
                          >
                            क्र
                          </label>
                          <div className="flex sm:h-5 ml-2">
                            {fillWithZeros(data.क्रमांक, 6).map((value, index) => (
                              <div
                                key={index}
                                type="text"
                                maxLength="1"
                                className="border text-center pointer-events-none flex items-center justify-center sm:p-3 lg:p-3 md:p-3 w-8"
                                value={value}
                                readOnly
                              >
                                {value}
                              </div>
                            ))}
                          </div>
                          <div className="flex mx-4 gap-2">
                            {["Tick", "Cross", "1/2", "OK"].map((label, idx) => (
                              <div key={idx} className="flex flex-col items-center gap-1">
                                <div
                                  className="flex w-full h-full cursor-pointer relative"
                                  onClick={async () => {
                                    const newState = (icons[idx] + 1) % 5;
                                    setIcons((prev) => {
                                      const copy = [...prev];
                                      copy[idx] = newState;
                                      return copy;
                                    });
                                    // Save to database
                                    await saveCheckboxState(idx, newState);
                                  }}
                                >
                                  {icons[idx] === 0 ? (
                                    <PanoramaFishEyeIcon sx={{ height: 40, width: 40, color: "black" }} />
                                  ) : icons[idx] === 1 ? (
                                    <CheckCircleOutlineIcon sx={{ height: 40, width: 40, color: "black" }} />
                                  ) : icons[idx] === 2 ? (
                                    <div className="relative">
                                      <PanoramaFishEyeIcon sx={{ height: 40, width: 40, color: "black" }} />
                                      <div className="absolute inset-0 flex items-center justify-center">
                                        <span className="text-black font-bold text-xl">✕</span>
                                      </div>
                                    </div>
                                  ) : icons[idx] === 3 ? (
                                    <div className="relative">
                                      <PanoramaFishEyeIcon sx={{ height: 40, width: 40, color: "black" }} />
                                      <div className="absolute inset-0 flex items-center justify-center">
                                        <span className="text-black font-bold text-sm">A/V</span>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="relative">
                                      <PanoramaFishEyeIcon sx={{ height: 40, width: 40, color: "black" }} />
                                      <div className="absolute inset-0 flex items-center justify-center">
                                        <span className="text-black font-bold text-sm">OK</span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                {/* <span className="text-xs font-medium text-gray-700">{label}</span> */}
                              </div>
                            ))}
                          </div>
                        </div>

                        {/* नियुक्ति दिनांक row */}
                        <div className="flex items-center mb-2 gap-2">
                          <label className="mr-2">नियुक्ति दिनांक</label>
                          {icon1 ? (
                            <div
                              className="flex cursor-pointer"
                              onClick={async () => {
                                setIcon1(false);
                                await saveAppointmentCheckbox(false);
                              }}
                            >
                              <CheckCircleOutlineIcon
                                sx={{ height: 40, width: 40, color: "black" }}
                              />
                            </div>
                          ) : (
                            <div
                              className="flex cursor-pointer"
                              onClick={async () => {
                                setIcon1(true);
                                await saveAppointmentCheckbox(true);
                              }}
                            >
                              <PanoramaFishEyeIcon
                                sx={{ height: 40, width: 40, color: "black" }}
                              />
                            </div>
                          )}
                          <div className="flex sm:h-[30px]">
                            {(newData["नियुक्ति तिथि"] || "00000000").split("").map((value, index) => (
                              <React.Fragment key={`नियुक्ति-दिनांक-${index}`}>
                                <div
                                  className="border bg-white border-black sm:flex sm:justify-center sm:items-center p-2 md:flex md:justify-center md:items-center lg:flex lg:justify-center lg:items-center text-center pointer-events-none"
                                  readOnly
                                >
                                  {value === " " ? <>&nbsp;&nbsp;</> : value}
                                </div>
                                {(index === 1 || index === 3) && <>&nbsp;&nbsp;</>}
                              </React.Fragment>
                            ))}
                          </div>
                        </div>

                        {/* नियुक्ति पत्र गुम हो गया / नियुक्ति नहीं है */}
                        <div className="flex items-center mb-2">
                          <label className="mr-2">नियुक्ति पत्र गुम हो गया</label>
                          {data.नियुक्ति_पत्र_गुम ? (
                            <div className="flex cursor-pointer">
                              <CheckCircleOutlineIcon
                                sx={{ height: 40, width: 40, color: "black" }}
                              />
                            </div>
                          ) : (
                            <div className="flex cursor-pointer">
                              <PanoramaFishEyeIcon
                                sx={{ height: 40, width: 40, color: "black" }}
                              />
                            </div>
                          )}
                          <label className="ml-4 mr-2">नियुक्ति नहीं है</label>
                          {data.नियुक्ति_नहीं ? (
                            <div className="flex cursor-pointer">
                              <CheckCircleOutlineIcon
                                sx={{ height: 40, width: 40, color: "black" }}
                              />
                            </div>
                          ) : (
                            <div className="flex cursor-pointer">
                              <PanoramaFishEyeIcon
                                sx={{ height: 40, width: 40, color: "black" }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      {/* Right section - Photo */}
                      <div className="flex items-center justify-center w-1/5">
                        <label
                          htmlFor="dropzone-file"
                          className="flex items-center justify-center cursor-pointer"
                        >
                          <div className="border-2 border-black rounded-lg overflow-hidden">
                            <img
                              src={data.imageURL || "https://via.placeholder.com/150"}
                              alt="Profile"
                              className="sm:h-36 sm:w-32 object-cover"
                            />
                          </div>
                        </label>

                      </div>
                      <div className="w-2/5 mt-4 pl-10">
                        <div className="flex">
                          <label className="block mb-1 w-1/5">अभिमत: -</label>
                          <div className="w-4/5">
                            {(() => {
                              const lines = splitTextByWords(data.अभिमत, 4, 35);
                              while (lines.length < 5) lines.push("");
                              return lines.map((line, idx) => (
                                <div
                                  key={idx}
                                  className="border-t border-black mb-2 whitespace-pre-line"
                                >
                                  <h1 className="-mt-2">{line || <>&nbsp;</>}</h1>
                                </div>
                              ));
                            })()}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>


                  {PersonalInfo?.slice(0, 13).map((item) => (
                    <div
                      className={`flex ${item.width
                        ? item.name === "व्यवसाय"
                          ? "w-custom-6"
                          : item.name === "दादाश्री"
                            ? "w-custom-10.5"
                            : item.name === "पिताश्री"
                              ? "w-custom-10"
                              : "w-custom-8"
                        : "sm:w-1/4 md:w-1/4 lg:w-1/4"
                        } gap-2 justify-between mb-4 p-1`}
                      key={item.name}
                    >
                      <label
                        className={`lassName=uppercase    flex sm:flex -mt-1.5 ${item.name === "दादाश्री"
                          // ? "sm:w-3/5 md:w-3/5 lg:w-3/5"
                          // : "sm:w-2/5 md:w-2/5 lg:w-2/5"
                          }


                            `}
                        style={{
                          whiteSpace: "nowrap",
                        }}
                        htmlFor="grid-password"
                      >
                        {item.label}
                      </label>
                      <div
                        className="pointer-events-none border-t-1 border-black-400  
                      sm:w-full
                      
                      //  md:w-full 
                       flex justify-center focus:outline-none focus:ring ease-linear transition-all duration-150"
                      >
                        <div
                          className="-my-1.5
                          //  w-5/6
                           text-center"
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {data[item.name] || "-"}
                        </div>
                      </div>
                    </div>
                  ))}



                  <div
                    className="flex w-full flex-wrap sm:gap-2
                  "
                  >
                    <div className="flex w-full gap-4">
                      {/* वि. field - 30% width, upper line only */}
                      <div
                        className="flex w-[26%] gap-2 justify-between mb-2 p-1"
                        key="वि"
                      >
                        <label
                          className="uppercase flex"
                          style={{ whiteSpace: "nowrap" }}
                          htmlFor="grid-password"
                        >
                          वि.
                        </label>
                        <div
                          className="pointer-events-none border-t-1 border-black-400  
                      sm:w-full
                      
                      //  md:w-full 
                       flex justify-center focus:outline-none focus:ring ease-linear transition-all duration-150"
                        >
                          <div className="-my-1.5 text-center" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                            {data.वि || "0"}
                          </div>
                        </div>
                      </div>
                      {/* लो. field - 30% width, upper line only */}
                      <div
                        className="flex w-[26%] gap-2 justify-between mb-2 p-1"
                        key="लो"
                      >
                        <label
                          className="uppercase flex"
                          style={{ whiteSpace: "nowrap" }}
                          htmlFor="grid-password"
                        >
                          लो.
                        </label>
                        <div
                          className="pointer-events-none border-t-1 border-black-400  
                      sm:w-full
                      
                       flex justify-center focus:outline-none focus:ring ease-linear transition-all duration-150"
                        >
                          <div className="-my-1.5 text-center" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                            {data.लो || "0"}
                          </div>
                        </div>
                      </div>
                      {/* Existing field - 40% width */}
                      <div className="flex flex-col w-[48%]">
                        {ContactInfo?.slice(0, 1).map((item) => (
                          <div
                            className="flex gap-4 items-center"
                            key={item.name}
                          >
                            <label
                              className="uppercase flex"
                              htmlFor="grid-password"
                            >
                              {item.label}
                            </label>
                            <div className="flex sm:h-[34px]">
                              {fillWithZeros(data.आधार_नं, 12).map((value, index) => (
                                <div
                                  className="border bg-white border-black flex items-center justify-center p-2 w-8 text-center pointer-events-none"
                                  key={`आधार-${index}`}
                                  readOnly
                                >
                                  {value}
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="flex w-full">
                      <div className="flex flex-col justify-between w-3/4 pr-4">
                        {PersonalInfo?.slice(13, 14).map((item) => (
                          <div
                            className="flex gap-2 justify-between w-full p-1"
                            key={item.name}
                          >
                            <label
                              className="uppercase flex"
                              htmlFor="grid-password"
                            >
                              {item.label} &nbsp;:-&nbsp; नाम
                            </label>
                            <div className="pointer-events-none border-t-1 border-black-400 flex justify-center w-1/3 focus:outline-none focus:ring ease-linear transition-all duration-150">
                              <div className="-my-1.5">{data.पारिवारिक_सदस्य_पटेल || "-"}</div>
                            </div>
                            <div className="flex items-center">
                              (&nbsp;&nbsp;
                              <div className="border-t-1 flex items-center justify-center border-black-400 w-2/3 focus:outline-none focus:ring ease-linear transition-all duration-150">
                                <div className="text-center w-full -mt-3 bg-transparent">
                                  {data.उत्तराधिकारी_नाम || "-"}
                                </div>
                              </div>
                              &nbsp;&nbsp;)
                            </div>
                          </div>
                        ))}
                      </div>
                      {/* Second section: 33% width */}
                      <div className="border-b-2 w-1/4 flex flex-col justify-center">
                        <div className="flex sm:h-[36px] items-center">
                          <label className="flex justify-center items-center sm:text-base lg:text-sm text-base mr-4">
                            मो.
                          </label>
                          {data?.उत्तराधिकारी_मो?.split("").map((value, index) => (
                            <div
                              key={index}
                              type="text"
                              maxLength="1"
                              className="border text-center pointer-events-none flex items-center justify-center p-1.5 h-9"
                              value={value}
                              readOnly
                            >
                              {value}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="flex w-full gap-4 my-2 justify-between">
                      <div className="flex justify-between w-3/5">
                        {ContactInfo?.slice(8).map((item) => (
                          <>
                            <label
                              // className="flex items-center "
                              className="flex items-center "
                              key={item.name}
                            >
                              {item.label}
                              <input
                                type="checkbox"
                                name="status"
                                checked={data[item.name]}
                                className="ml-2 size-5 sm:size-7"
                              />
                            </label>
                          </>
                        ))}
                      </div>
                      <div className="flex w-1/3 gap-2 justify-between items-center mr-8">
                        <label
                          className="uppercase flex sm:flex -mt-1.5"
                          style={{ whiteSpace: "nowrap" }}
                          htmlFor="grid-password"
                        >
                          पेनकार्ड
                        </label>
                        <div className="flex h-[34px]">
                          {fillWithZeros(data.पेनकार्ड, 10).map((value, index) => (
                            <div
                              key={index}
                              className="border border-black text-center pointer-events-none flex items-center justify-center p-2.5 w-8"
                              readOnly
                            >
                              {value}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <>


                      <div className="flex gap-2">
                        <label
                          className="uppercase flex sm:flex -mt-1.5 items-center"
                          style={{ whiteSpace: "nowrap" }}
                          htmlFor="grid-password"
                        >
                          शिक्षा → कक्षा
                        </label>
                        <div className="flex gap-2">
                          {/* First part: शिक्षा_कक्षा in boxes */}
                          <div className="flex">
                            {fillWithZeros(data.शिक्षा_कक्षा, 2).map((value, index) => (
                              <div
                                key={`शिक्षा-कक्षा-${index}`}
                                className="border text-center pointer-events-none flex items-center justify-center p-2 w-8"
                                readOnly
                              >
                                {value}
                              </div>
                            ))}
                          </div>
                          {/* Second part: Static BCom removed, show data if needed */}
                          <div className="flex">
                            <div
                              className="border text-center pointer-events-none flex items-center justify-center p-2 w-24"
                              readOnly
                            >
                              {data.शिक्षा_डिग्री || ""}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="flex md:w-auto sm:w-auto gap-4 md:gap-2" key="परिवार आईडी">
                        <label
                          className="uppercase lg:items-center -mt-1 lg:justify-center sm:items-center sm:justify-center r flex sm:w-1/2 md:w-1/2 md:p-0"
                          htmlFor="grid-password"
                        >
                          परिवार आईडी
                        </label>
                        <div className="flex sm:h-[36px]">
                          {fillWithZeros(data.परिवार_आईडी, 12).map((value, index) => (
                            <div
                              key={`परिवारआईडी-${index}`}
                              className="p-2 border bg-white border-black sm:flex sm:justify-center sm:items-center md:flex md:justify-center md:items-center lg:flex lg:justify-center lg:items-center text-center pointer-events-none "
                              readOnly
                            >
                              {value}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="flex md:w-auto sm:w-auto gap-4 items-center w-full" key={dobField.name}>
                        <label
                          className="uppercase items-center -mt-2 flex sm:w-1/2 md:w-2/3"
                          htmlFor="grid-password"
                        >
                          {dobField.label}
                        </label>
                        <div className="flex sm:h-[36px] -mt-2">
                          {(newData["जन्म दिन दिनांक"] || "00000000").split("").map((value, index) => (
                            <React.Fragment key={`जन्म-दिनांक-${index}`}>
                              <div
                                className="border bg-white border-black sm:flex sm:justify-center sm:items-center p-2 md:flex md:justify-center md:items-center lg:flex lg:justify-center lg:items-center text-center pointer-events-none"
                                readOnly
                              >
                                {value === " " ? <>&nbsp;&nbsp;</> : value}
                              </div>
                              {(index === 1 || index === 3) && <>&nbsp;&nbsp;</>}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    </>
                  </div>
                </div>
                <div className="flex w-full my-2 h-8">
                  {/* MOCK BANK NAME AND ACCOUNT NUMBER DISPLAY */}
                  <div className="flex w-2/5 gap-2 justify-between it">
                    <label
                      className="uppercase flex sm:flex -mt-1.5"
                      style={{ whiteSpace: "nowrap" }}
                      htmlFor="grid-password"
                    >
                      बैंक का नाम
                    </label>
                    <div className=" pointer-events-none border-t-1 border-black w-5/6 flex justify-center focus:outline-none focus:ring ease-linear transition-all duration-150">
                      <div className=" text-center -mt-1.5" style={{ whiteSpace: "nowrap", overflow: "hidden" }}>
                        {data.बैंक_का_नाम || "0"}
                      </div>
                    </div>
                  </div>
                  <div className="flex w-3/5 gap-2 justify-between items-center">
                    <label
                      className="uppercase flex sm:flex -mt-1.5"
                      style={{ whiteSpace: "nowrap" }}
                      htmlFor="grid-password"
                    >
                      खाता नं.
                    </label>
                    <div className="flex h-[36px]">
                      {fillWithZeros(data.खाता_नं, 20).map((value, index) => (
                        <div
                          key={index}
                          className="border border-black text-center pointer-events-none flex items-center justify-center p-2 w-7"
                          readOnly
                        >
                          {value}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="  flex  justify-between sm:flex-wrap sm:flex-row  sm:w-full sm:mt- items-center my-4 mdLmb-4 ">
                  <div className="   border-b-2">
                    <div className="flex sm:h-[36px] ">
                      <label className="flex justify-center items-center   sm:text-base lg:text-sm text-base mr-4 ">
                        मो.
                      </label>

                      {data?.मो_बैंक?.split("").map((value, index) => (
                        <div
                          type="text"
                          maxLength="1"
                          className="border text-center  pointer-events-none flex items-center justify-center sm:p-2.5 sm:text lg:p-2.5 lg:text-sm md:text-sm  md:p-2.5 "
                          value={value}
                          readOnly
                        >
                          {value}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="   border-b-2 -mt-2">
                    <label
                      className="flex justify-center items-center  uppercase  mb-2"
                      htmlFor="grid-password"
                    ></label>
                    <div className="flex sm:h-[36px] ">
                      {fillWithZeros(data?.मो, 10).map((value, index) => (
                        <div
                          key={index}
                          type="text"
                          maxLength="1"
                          className="border text-center   pointer-events-none flex items-center justify-center sm:p-2.5 lg:p-2.5   md:p-2.5 "
                          value={value}
                          readOnly
                        >
                          {value}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="border-b-2 flex gap-2">
                    <label
                      className="flex justify-center items-center uppercase "
                      htmlFor="grid-password"
                    >IFSC</label>
                    <div className="flex sm:h-[36px] ">
                      {fillWithZeros(data.IFSC, 11).map((value, index) => (
                        <div
                          key={index}
                          type="text"
                          maxLength="1"
                          className="border text-center  pointer-events-none flex items-center justify-center sm:p-2.5 lg:p-2.5   md:p-2.5 "
                          value={value}
                          readOnly
                        >
                          {value}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-between  mb-4">
                  <div className="flex items-center justify-center sm:items-center   sm:justify-center ">
                    <h1>उपस्थिति :-</h1>
                  </div>
                  {Array.from({ length: 10 }).map((_, index) => (
                    <div
                      key={index}
                      className="flex flex-col h-14 w-20 border border-black"
                    >
                      <div className="flex flex-1 items-center justify-center border-b-2">
                        {data && data[`उपस्थिति_अंक_${index}`] && data[`उपस्थिति_अंक_${index}`] !== "0"
                          ? data[`उपस्थिति_अंक_${index}`]
                          : ""}
                      </div>
                      <div className="flex justify-between flex-1">
                        {(() => {
                          const dateStr = data && data[`उपस्थिति_दिनांक_${index}`] && data[`उपस्थिति_दिनांक_${index}`] !== ""
                            ? data[`उपस्थिति_दिनांक_${index}`]
                            : "";
                          const parts = extractDateParts(dateStr);
                          return (
                            <>
                              <div className="w-1/3 p-0 border-t border-black flex items-center justify-center">
                                {parts.day && parts.day !== "undefined" && dateStr !== "" ? parts.day : ""}
                              </div>
                              <div className="w-1/3 p-0 border-r border-l border-t border-black flex items-center justify-center">
                                {parts.month && parts.month !== "undefined" && dateStr !== "" ? parts.month : ""}
                              </div>
                              <div className="w-1/3 p-0 border-t border-black flex items-center justify-center">
                                {parts.year && parts.year !== "undefined" && dateStr !== "" ? parts.year : ""}
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  ))}
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    return (
      <div className="">
        <div
          role="status"
          className="flex items-center justify-center h-screen"
        >
          <svg
            aria-hidden="true"
            class="inline w-10 h-10 text-black-200 animate-spin dark:text-black-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    );
  }
}

export default Profile;